import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import isSameBefore from 'dayjs/plugin/isSameOrBefore';
import isSameAfter from 'dayjs/plugin/isSameOrAfter';

export function setupDayjs() {
  dayjs.extend(utc);
  dayjs.extend(timezone);
  dayjs.extend(isSameBefore);
  dayjs.extend(isSameAfter);
}
